import { Component, OnInit, Injector, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SettingService } from 'src/app/shared/services/setting.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { PageService } from 'src/app/services/page.service';
import { finalize } from 'rxjs/operators';
import { ModalDisplayComponent } from 'src/app/shared/components/modal-display/modal-display.component';
import { ModalController, NavParams } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { ForgotPasswordPageComponent } from '../forgot-password-page/forgot-password-page.component';
import { RegisterPageComponent } from '../register-page/register-page.component';
import { LoginPageComponent } from '../login-page/login-page.component';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-authentication-page',
    templateUrl: './authentication-page.component.html',
    styleUrls: ['./authentication-page.component.scss'],
    standalone: false
})
export class AuthenticationPageComponent implements OnInit {
  // this is what i'll be using to change the looks to match the the home page calling this
  //@Input() sectionFormat?: boolean = false;
  
  title: string = 'Nav.Login';

  disableHeader: boolean = false;
  isPopup: boolean = false;
  mobile: boolean = false;

  logo!: SafeUrl;

  get privacyPolicyUrl() {
    return this.setting.getSeeMyPassUrl(`${this.translationService.getLanguage()}/privacy`);
  }

  constructor(private router: Router,
              //private translate: TranslateService,
              public setting: SettingService,
              private loaderService: LoaderService,
              private pageService: PageService,
              private modalCtrl: ModalController,
              private injector: Injector,
              private analytics: AnalyticsService,
              private translationService: TranslationService,
              private sanitizer: DomSanitizer
              ) { }

  ngOnInit() {
    //this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.apiUrl("/Menu/GetMenuItemImage?name=" + this.setting.configuration.logoShortName));
    
    if(this.setting.configuration?.logoShortName) {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.apiUrl("/Menu/GetMenuItemImage?name=" + this.setting.configuration.logoShortName));
    } else if(this.setting.configuration?.logoUrl) {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.configuration?.logoUrl);
    } else {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(null);
    }
    
    //this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.configuration?.logoUrl);

    /*
    const interval = setInterval(() => {
      if (this.setting.logoReady) {
        
        this.logo = this.setting.logo;

        console.log(this.logo);
        clearInterval(interval);
      }
    }, 100);
    */
    this.analytics.UpdateLocation({url: "/auth", ispopup: false},  true, false);

    const navParams = this.injector.get(NavParams, null);
    
        
    try {
      if(navParams.get('disableHeader') != undefined) {
        this.disableHeader = navParams.get('disableHeader');
        this.isPopup = true;
      }
    } catch (e) {

    }

    if(this.isPopup) {
      if (window.innerWidth <= 600) {
        this.mobile = true;
  
        this.disableHeader = false;
      } else {
        this.mobile = false;
  
        this.disableHeader = true;
      }
    }

    // temporarily. we'll need to set it up on the page soon
    (window as any).updateLoaderProgress(100);
    (window as any).finishAppShell?.();
  }

  @HostListener('window:resize', ['$event'])  
    onResize(event) { 
      if(this.isPopup) {
        if (window.innerWidth <= 600) { // follows the value of the modal
          this.mobile = true;
          this.disableHeader = false;
        } else {
          this.mobile = false;
          this.disableHeader = true;
        }
      } 
    } 

  async termsOfUse() {
    
    const loader = await this.loaderService.create();
    /*
    this.pageService
      .getTerms()
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(async (result) => {
        const requestModal = await this.modalCtrl.create({
          component: ModalDisplayComponent,
          componentProps: {
            title: "General.Terms",
            content: result
          }
        });

        await requestModal.present();
      });
      */
    this.setting.getSATerms(this.translationService.getLanguage())
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(async terms => {
        const requestModal = await this.modalCtrl.create({
          component: ModalDisplayComponent,
          componentProps: {
            title: "General.Terms",
            content: terms
          }
        });

        await requestModal.present();
      });
  }

  async policies() {
    const loader = await this.loaderService.create();
    this.setting.getSAPolicies(this.translationService.getLanguage())
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(async terms => {
        const requestModal = await this.modalCtrl.create({
          component: ModalDisplayComponent,
          componentProps: {
            title: "General.Policies",
            content: terms
          }
        });

        await requestModal.present();
      });
  }


  

  async goToLogin() {
    
    if(this.setting.configuration.uIoptions?.loginToPopup) {
      this.closePopup();    

      // prevents crash if the undocked navbar is inside a popup
      const modal = await this.modalCtrl.create({
        component: LoginPageComponent,
        cssClass: 'login-popup-model',
        componentProps: {
          disableHeader: false
        }
      });
    
      modal.onWillDismiss()
        .then((result) => {
          
      });
    
      await modal.present();
    } else {
      this.router.navigateByUrl('/auth/login');
    }
  }

  async goToRegister() {
    if(this.setting.configuration.uIoptions?.loginToPopup) {
      this.closePopup();    

      // prevents crash if the undocked navbar is inside a popup
      const modal = await this.modalCtrl.create({
        component: RegisterPageComponent,
        cssClass: 'register-popup-model',
        componentProps: {
          disableHeader: false
        }
      });
    
      modal.onWillDismiss()
        .then((result) => {
          
      });
    
      await modal.present();
    } else {
      this.router.navigateByUrl('/auth/register');
    }
    
  }

  async goToForgotPassword() {
    if(this.setting.configuration.uIoptions?.loginToPopup) {
      this.closePopup();    

      // prevents crash if the undocked navbar is inside a popup
      const modal = await this.modalCtrl.create({
        component: ForgotPasswordPageComponent,
        cssClass: 'passForgot-popup-model',
        componentProps: {
          disableHeader: false
        }
      });
    
      modal.onWillDismiss()
        .then((result) => {
          
      });
    
      await modal.present();
    } else {
      this.router.navigateByUrl('/auth/forgot-password');
    }
  }

  closePopup(){
    if(this.isPopup) {
      this.modalCtrl.dismiss();
    }
  }
}
